/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/contrast-1214367': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm-1 17.93a8 8 0 010-15.86zm2 0V4.07a8 8 0 010 15.86z"/>'
  }
})
